(function() {
    var module;

    try {
        // Get current templates module
        module = angular.module('templates');
    } catch (error) {
        // Or create a new one
        module = angular.module('templates', []);
    }

    module.run(["$templateCache", function($templateCache) {
        $templateCache.put('player/start.html', '<div class=\"mobile-step mobile-step--start\">\n	<div class=\"step_scroll\">\n	<figure class=\"step_header header--image\">\n		<img ng-src=\"{{baseurl}}/images/logo.svg\" />\n	</figure>\n	<div class=\"step_content\">\n\n		<h3 class=\"step_title\">Meld je aan met de PINcode en doe mee met de klas!</h3>\n\n		<label class=\"field field--text\">\n			<span class=\"label label--placeholder\">Vul hier de code in</span>\n			<input class=\"input\" ng-model=\"code\" animated-input-label>\n		</label>\n\n	</div>\n	</div>\n<button class=\"btn\" ng-click=\"start()\">Aanmelden</button>\n</div>\n');
    }]);
})();